<template>
  <div class="container">
    <v-header></v-header>

    <div class="searchBody">
      <div class="psearch">
        <img src="../../assets/logo.png" class="logo" />
        <label>想象无界,创意无边</label>
        <input type="text" class="prosearch" />
        <input type="button" value="搜索" class="submitsearch" />
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
import header from "../header";
import footer from "../footer";

export default {
  name: "shopCart",
  components: {
    "v-header": header,
    "v-footer": footer
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}

.searchBody {
  width: 100%;
  height: 144px;
  background-color: #fff;
  .psearch {
    width: 1200px;
    height: 144px;
    background-color: #fff;
    line-height: 140px;
    margin: 0 auto;
    position: relative;
    .logo {
      position: absolute;
      top: 40px;
    }
    label {
      height: 50px;
      line-height: 50px;
      position: absolute;
      top: 40px;
      left: 220px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
    }
    .prosearch {
      width: 400px;
      height: 48px;
      line-height: 48px;
      top: 40px;
      right: 80px;
      position: absolute;
      border: 0;
      border: 2px solid red;
      font-size: 20px;
    }
    .submitsearch {
      width: 80px;
      height: 52px;
      background-color: red;
      border-radius: 0;
      color: white;
      font-size: 15px;
      border: 0;
      top: 40px;
      right: 0px;
      position: absolute;
    }
  }
}

.shopType {
  width: 1200px;
  height: 80px;
  position: relative;
  background-color: #fff;
  margin: 25px auto;

  .typeTitle {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    padding: 16px 0 0 25px;
    position: absolute;
  }

  .line {
    width: 1px;
    height: 10px;
    background: rgba(232, 232, 232, 1);
    position: absolute;
    margin: 21px 0 0 108px;
  }
}
</style>
